export default __webpack_public_path__ + "static/media/5.662a5c51.jpg";